export const projectReducer = (state, action) => {
    switch(action.type) {
        case 'ADD_PROJECT':
            return [...state, {
                    id: action.project.id, 
                    createdOn: action.project.createdOn,
                    name: action.project.name,
                    section: action.project.section,
                    needle: action.project.needle ,
                    stitchName: action.project.stitch,
                    rowCount: action.project.rowCount,
                    stitchCount: action.project.stitchCount, 
                    yarn: action.project.yarn,
                    notes: action.project.notes
                }]
        case 'REMOVE_PROJECT':
            return state.filter(project => project.id !== action.id)
        case 'UPDATE_PROJECT':
            return state.map(item => {
                if(item.id === action.project.id){
                    return {...item, [action.project.info]: action.project.name}
                }
                return item;
            })
        case 'UPDATE_COUNT':
            return state.map(item => {
                if(item.id === action.project.id){
                    return {...item, [action.project.name]: action.project.info}
                }
                return item;
            })
        default:
            return state
    }
}